import { render, staticRenderFns } from "./CourtesyPromotionalList.vue?vue&type=template&id=676a3900"
import script from "./CourtesyPromotionalList.vue?vue&type=script&lang=js"
export * from "./CourtesyPromotionalList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports